/* 🤖 this file was generated by svg-to-ts */
export const siriusCopyrightDuotone: {
  name: 'copyright_duotone';
  data: string;
} = {
  name: 'copyright_duotone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path opacity=".2" d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" fill="currentColor"/><path d="M11.051 9.154A3 3 0 0 1 14.4 10.2a.75.75 0 1 0 1.2-.9 4.5 4.5 0 1 0 0 5.4.75.75 0 1 0-1.2-.9 3 3 0 1 1-3.349-4.646Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM3.75 12a8.25 8.25 0 1 1 16.5 0 8.25 8.25 0 0 1-16.5 0Z" fill="currentColor"/></svg>`
};
